import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, useLocation, useParams } from 'react-router-dom';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../utils';
import Chip from '../../../common/base/Chip';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { OutpostDataCollapsibleSection } from './OutpostDataSection';
import { OutpostMetadataCollapsibleSection } from './OutpostMetadataSection';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, StyledViewSplitPaneContent, StyledViewSplitPaneLayout, StyledViewSplitPaneSidebar, StyledViewSplitPaneSidebarBody, ViewBreadcrumbsTitle, ViewMetadataCopyable, ViewMetadataItem, ViewSplitPaneContentHeader, ViewSplitPaneSidebarHeader } from '../../../layouts/ViewLayout';
import { DashboardContext } from '../../DashboardScene/DashboardContext';
import NotFound from '../../DashboardScene/NotFound';
import AttemptSidebar from '../Attempts/AttemptSidebar';
import AttemptsList from '../Attempts/AttemptsList';
import { OUTPOST_ATTEMPT_INCLUDES } from '../Attempts/utils';
import useRetryAttempt from '../Attempts/useRetryAttempt';
import { getOutpostTenantLabel, useOutpostTenantsById } from '../utils/tenantDisplay';
interface Query {
  selected_attempt_id?: string | string[];
  tab?: string | string[];
}
const EventOverview: React.FC<{
  event_id: string;
  tenant_id: string;
  tenant_label: string;
  destination_id?: string;
  time: string;
  topic: string;
  metadata_as_headers: Record<string, string>;
  data: Record<string, unknown>;
}> = t0 => {
  const $ = _c(31);
  const {
    event_id,
    tenant_id,
    tenant_label,
    destination_id,
    time,
    topic,
    metadata_as_headers,
    data
  } = t0;
  const {
    is_degraded_banner_active
  } = useContext(DashboardContext);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViewSplitPaneSidebarHeader title="Event details" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `/tenants/${tenant_id}`;
  let t3;
  if ($[1] !== t2 || $[2] !== tenant_label) {
    t3 = <ViewMetadataItem label="Tenant"><Chip outline={true} label={tenant_label} to={t2} /></ViewMetadataItem>;
    $[1] = t2;
    $[2] = tenant_label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== topic) {
    t4 = <ViewMetadataItem label="Topic"><Text mono={true} size="s">{topic}</Text></ViewMetadataItem>;
    $[4] = topic;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== destination_id || $[7] !== tenant_id) {
    t5 = destination_id && <ViewMetadataItem label="Destination"><Chip mono={true} outline={true} label={destination_id} to={`/tenants/${tenant_id}/destinations/${destination_id}`} /></ViewMetadataItem>;
    $[6] = destination_id;
    $[7] = tenant_id;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== time) {
    t6 = <ViewMetadataItem label="Timestamp"><Text mono={true} size="s">{time}</Text></ViewMetadataItem>;
    $[9] = time;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== event_id) {
    t7 = <ViewMetadataItem label="Event ID"><ViewMetadataCopyable value={event_id} /></ViewMetadataItem>;
    $[11] = event_id;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <StyledViewSplitPaneSidebar><StyledViewSplitPaneSidebarBody>{t1}{t3}{t4}{t5}{t6}{t7}</StyledViewSplitPaneSidebarBody></StyledViewSplitPaneSidebar>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ViewSplitPaneContentHeader title="Event data" />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== metadata_as_headers) {
    t10 = <OutpostMetadataCollapsibleSection metadata={metadata_as_headers} embedded={false} />;
    $[20] = metadata_as_headers;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== data) {
    t11 = data && <OutpostDataCollapsibleSection data={data} embedded={false} />;
    $[22] = data;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <StyledViewSplitPaneContent>{t9}{t10}{t11}</StyledViewSplitPaneContent>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== is_degraded_banner_active || $[28] !== t12 || $[29] !== t8) {
    t13 = <StyledViewSplitPaneLayout banner_active={is_degraded_banner_active}>{t8}{t12}</StyledViewSplitPaneLayout>;
    $[27] = is_degraded_banner_active;
    $[28] = t12;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
const EventView: React.FC = () => {
  const $ = _c(94);
  const {
    id: event_id
  } = useParams();
  const {
    pathname
  } = useLocation();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t0;
  if ($[0] !== query.selected_attempt_id) {
    t0 = extractFromArray(query.selected_attempt_id);
    $[0] = query.selected_attempt_id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selected_attempt_id = t0 as string;
  let t1;
  if ($[2] !== event_id) {
    t1 = APIMethodKeys.outpost.events.get(event_id);
    $[2] = event_id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== HookdeckAPI.outpost.events || $[5] !== event_id) {
    t2 = () => HookdeckAPI.outpost.events.get(event_id);
    $[4] = HookdeckAPI.outpost.events;
    $[5] = event_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: event,
    error
  } = useSWR(t1, t2);
  let t3;
  if ($[7] !== event || $[8] !== event_id) {
    t3 = event ? APIMethodKeys.outpost.attempts.list({
      event_id,
      include: OUTPOST_ATTEMPT_INCLUDES
    }) : null;
    $[7] = event;
    $[8] = event_id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== HookdeckAPI.outpost.attempts || $[11] !== event_id) {
    t4 = () => HookdeckAPI.outpost.attempts.list({
      event_id,
      include: OUTPOST_ATTEMPT_INCLUDES
    });
    $[10] = HookdeckAPI.outpost.attempts;
    $[11] = event_id;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const {
    data: attempts_response,
    mutate: mutate_attempts,
    isLoading: attempts_response_loading
  } = useSWR(t3, t4);
  let t5;
  if ($[13] !== mutate_attempts) {
    t5 = async () => {
      await mutate_attempts();
    };
    $[13] = mutate_attempts;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    retryAttempt,
    retrying_attempt_id
  } = useRetryAttempt(t5);
  let t6;
  if ($[15] !== attempts_response?.models) {
    t6 = attempts_response?.models || [];
    $[15] = attempts_response?.models;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const attempts = t6;
  let t7;
  if ($[17] !== updateSearchQuery) {
    t7 = id => updateSearchQuery({
      selected_attempt_id: id || undefined
    });
    $[17] = updateSearchQuery;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const onAttemptSelected = t7;
  let t8;
  if ($[19] !== attempts || $[20] !== onAttemptSelected || $[21] !== selected_attempt_id) {
    t8 = () => {
      if (!selected_attempt_id || !attempts.length) {
        return;
      }
      const current_index = attempts.findIndex(attempt => attempt.id === selected_attempt_id);
      if (current_index > 0) {
        onAttemptSelected(attempts[current_index - 1].id);
      }
    };
    $[19] = attempts;
    $[20] = onAttemptSelected;
    $[21] = selected_attempt_id;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const onPrevAttempt = t8;
  let t9;
  if ($[23] !== attempts || $[24] !== onAttemptSelected || $[25] !== selected_attempt_id) {
    t9 = () => {
      if (!selected_attempt_id || !attempts.length) {
        return;
      }
      const current_index_0 = attempts.findIndex(attempt_0 => attempt_0.id === selected_attempt_id);
      if (current_index_0 < attempts.length - 1) {
        onAttemptSelected(attempts[current_index_0 + 1].id);
      }
    };
    $[23] = attempts;
    $[24] = onAttemptSelected;
    $[25] = selected_attempt_id;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const onNextAttempt = t9;
  let t10;
  if ($[27] !== attempts || $[28] !== selected_attempt_id) {
    let t11;
    if ($[30] !== selected_attempt_id) {
      t11 = attempt_1 => attempt_1.id === selected_attempt_id;
      $[30] = selected_attempt_id;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    t10 = attempts.find(t11);
    $[27] = attempts;
    $[28] = selected_attempt_id;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const selected_attempt = t10;
  const t11 = event?.tenant_id;
  let t12;
  if ($[32] !== t11) {
    t12 = [t11];
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const {
    tenants_by_id
  } = useOutpostTenantsById(t12);
  if (error?.response?.status === 404) {
    let t13;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = {
        to: "/events",
        text: "All Events"
      };
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== event_id) {
      t14 = <NotFound title="Event not found" description="This event may have been deleted or does not exist." id={event_id} link={t13} />;
      $[35] = event_id;
      $[36] = t14;
    } else {
      t14 = $[36];
    }
    return t14;
  }
  if (!event) {
    let t13;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <StyledViewLayout><StyledViewContent><Div flex={{
            grow: true,
            align: "center",
            justify: "center"
          }}><Loading /></Div></StyledViewContent></StyledViewLayout>;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    return t13;
  }
  let t13;
  if ($[38] !== event.metadata) {
    t13 = event.metadata ? Object.fromEntries(Object.entries(event.metadata).map(_temp)) : {};
    $[38] = event.metadata;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  const metadata_as_headers = t13;
  const current_status = pathname.endsWith("/attempts") ? "attempts" : "overview";
  const t14 = tenants_by_id[event.tenant_id];
  let t15;
  if ($[40] !== event.tenant_id || $[41] !== t14) {
    t15 = getOutpostTenantLabel(event.tenant_id, t14);
    $[40] = event.tenant_id;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const tenant_label = t15;
  let t16;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      label: "Events",
      to: "/events"
    };
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== event_id) {
    t17 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={[t16, {
        label: event_id,
        highlight: true
      }]} /></StyledViewNavHeader>;
    $[44] = event_id;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== updateSearchQuery) {
    t18 = tab => updateSearchQuery({
      tab,
      selected_attempt_id: undefined
    });
    $[46] = updateSearchQuery;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  const t19 = `/events/${event_id}`;
  let t20;
  if ($[48] !== t19) {
    t20 = {
      label: "Overview",
      key: "overview",
      to: t19
    };
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const t21 = `/events/${event_id}/attempts`;
  const t22 = attempts_response?.models.length;
  let t23;
  if ($[50] !== t21 || $[51] !== t22) {
    t23 = {
      label: "Delivery Attempts",
      key: "attempts",
      to: t21,
      badge_theme: "muted",
      badge_label: t22
    };
    $[50] = t21;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t20 || $[54] !== t23) {
    t24 = [t20, t23];
    $[53] = t20;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== current_status || $[57] !== t18 || $[58] !== t24) {
    t25 = <StyledViewNavSecondary><Tabs active_tab={current_status} border={false} onTabSelected={t18} tabs={t24} /></StyledViewNavSecondary>;
    $[56] = current_status;
    $[57] = t18;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t17 || $[61] !== t25) {
    t26 = <StyledViewNav>{t17}{t25}</StyledViewNav>;
    $[60] = t17;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== event.data || $[64] !== event.destination_id || $[65] !== event.id || $[66] !== event.tenant_id || $[67] !== event.time || $[68] !== event.topic || $[69] !== metadata_as_headers || $[70] !== tenant_label) {
    t27 = <Route exact={true} path="/events/:id"><EventOverview event_id={event.id} tenant_id={event.tenant_id} tenant_label={tenant_label} destination_id={event.destination_id} time={event.time} topic={event.topic} metadata_as_headers={metadata_as_headers} data={event.data} /></Route>;
    $[63] = event.data;
    $[64] = event.destination_id;
    $[65] = event.id;
    $[66] = event.tenant_id;
    $[67] = event.time;
    $[68] = event.topic;
    $[69] = metadata_as_headers;
    $[70] = tenant_label;
    $[71] = t27;
  } else {
    t27 = $[71];
  }
  let t28;
  if ($[72] !== attempts_response || $[73] !== attempts_response_loading || $[74] !== onAttemptSelected || $[75] !== retryAttempt || $[76] !== retrying_attempt_id || $[77] !== selected_attempt_id) {
    t28 = <Route exact={true} path="/events/:id/attempts"><AttemptsList attempts_response={attempts_response} loading={attempts_response_loading} selected_attempt_id={selected_attempt_id} onAttemptSelected={onAttemptSelected} onRetryAttempt={retryAttempt} retrying_attempt_id={retrying_attempt_id} current_page={1} /></Route>;
    $[72] = attempts_response;
    $[73] = attempts_response_loading;
    $[74] = onAttemptSelected;
    $[75] = retryAttempt;
    $[76] = retrying_attempt_id;
    $[77] = selected_attempt_id;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== t26 || $[80] !== t27 || $[81] !== t28) {
    t29 = <StyledViewContent>{t26}{t27}{t28}</StyledViewContent>;
    $[79] = t26;
    $[80] = t27;
    $[81] = t28;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  let t30;
  if ($[83] !== onNextAttempt || $[84] !== onPrevAttempt || $[85] !== retryAttempt || $[86] !== retrying_attempt_id || $[87] !== selected_attempt || $[88] !== selected_attempt_id || $[89] !== updateSearchQuery) {
    t30 = selected_attempt_id && <AttemptSidebar attempt_id={selected_attempt_id} list_attempt={selected_attempt} onRetryAttempt={retryAttempt} retrying_attempt_id={retrying_attempt_id} onPrev={onPrevAttempt} onNext={onNextAttempt} onClose={() => updateSearchQuery({}, {
      remove_keys: ["selected_attempt_id"]
    })} />;
    $[83] = onNextAttempt;
    $[84] = onPrevAttempt;
    $[85] = retryAttempt;
    $[86] = retrying_attempt_id;
    $[87] = selected_attempt;
    $[88] = selected_attempt_id;
    $[89] = updateSearchQuery;
    $[90] = t30;
  } else {
    t30 = $[90];
  }
  let t31;
  if ($[91] !== t29 || $[92] !== t30) {
    t31 = <StyledViewLayout>{t29}{t30}</StyledViewLayout>;
    $[91] = t29;
    $[92] = t30;
    $[93] = t31;
  } else {
    t31 = $[93];
  }
  return t31;
};
export default EventView;
function _temp(t0) {
  const [key, value] = t0;
  return [key, typeof value === "object" ? JSON.stringify(value) : String(value ?? "")];
}